var _path, _defs, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignCityBackEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_city_x5F_back_x5F_eu_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_city_x5F_back_x5F_eu_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2B236"
    },
    d: "M90,82H6c-2.209,0-4-1.791-4-4V18c0-2.209,1.791-4,4-4h84c2.209,0,4,1.791,4,4v60 C94,80.209,92.209,82,90,82z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90,16H6c-1.105,0-2,0.895-2,2v60c0,1.105,0.895,2,2,2h84c1.105,0,2-0.895,2-2V18C92,16.895,91.105,16,90,16z M90,18v29H6 V18H90z M6,78V49h84v29H6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 6,
    y: 49,
    width: 84,
    height: 29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.22,
    y: 60,
    transform: "matrix(0.9603 -0.2791 0.2791 0.9603 -15.8165 15.9216)",
    style: {
      fill: "#B33229"
    },
    width: 89.56,
    height: 7.001
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80,22.171 74,28.172 74,33.828 78,29.828 78,44 82,44 82,29.828 86,33.828 86,28.172  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignCityBackEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_city_back_eu.64741213f0264479cd194cc8e7680682.svg";
export { ForwardRef as ReactComponent };